import {axios} from "../../config/axios";

export const campaignRewardAPI = {
  create(ownerId, ownerType) {
    return axios.post(`/api/v3/campaign_rewards`, {
      owner_id: ownerId,
      owner_type: ownerType
    }).then(resp => resp.data);
  },
  fetch(rewardId, ownerId, ownerType) {
    return axios.get(`/api/v3/campaign_rewards/${rewardId}`, {
      params: {
        owner_id: ownerId,
        owner_type: ownerType
      }
    }).then((resp) => resp.data);
  },
  patchRewards(rewardId, frag) {
    return axios.patch(`/api/v3/campaign_rewards/${rewardId}`, frag)
      .then((resp) => resp.data)
  }
}
